import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  import { controls } from "../../controls";
  
  
  const minbalance = {
    label: "Min Balance",
    pageLabel: "Min Balance",
    starting: true,
    url: "minbalance",
    pageType: "history",
    formState: { checked: "view" },
    formActions: { edit: { allow: true }, delete: { allow: true } },
    // "Address.",
    form:[
        {
            inputType: "displaytext",
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Branch",
            label: "Parent Branch",
            name: "branch",
            description: "Enter Branch"
          },
          {
            inputType: "autocomplete",
            tab: "overdraft",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getRegionCode"
              }
            },
            options: [
              {
                label: "branch-1",
                value: "branch-1"
              },
              {
                label: "branch-2",
                value: "branch-2"
              },
              {
                label: "branch-3",
                value: "branch-3"
              }
            ],
            placeHolder: "Branch Code",
            //   label: "Branch Code",
            name: "branch",
            description: "Enter branch code"
          },
          {
            inputType: "showdata",
            tab: "overdraft",
            data: "branch",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
          {
            inputType: "displaytext",
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Product",
            label: "Product",
            name: "",
            description: "Enter Product"
          },
      
          {
            inputType: "autocomplete",
            isRequired: true,
            tab: "overdraft",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getRegionCode"
              }
            },
            options: [
              {
                label: "product1",
                value: "product1"
              },
              {
                label: "product2",
                value: "product2"
              },
              {
                label: "product3",
                value: "product3"
              }
            ],
            placeHolder: "Branch Code",
            //   label: "Branch Code",
            name: "product",
            description: "Enter 2 digit branch code"
          },
          {
            inputType: "showdata",
            tab: "overdraft",
            data: "product",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
      
          {
            inputType: "displaytext",
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Search",
            label: "Search",
            name: "",
            description: "Enter Search Text"
          },
          {
            inputType: "text",
            tab: "overdraft",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Enter Search",
            label: "",
            name: "search",
            description: "Enter Search"
          },
          {
            inputType: "displaytext",
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Customer Type",
            label: "Customer Type",
            name: "branch",
            description: "Select Customer Type"
          },
          {
            inputType: "select",
            tab: "overdraft",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getRegionCode"
              }
            },
            options: [
              {
                label: "indivisual",
                value: "indivisual"
              },
              {
                label: "internal",
                value: "internal"
              },
              {
                label: "Other",
                value: "Other"
              }
            ],
            placeHolder: "Customer Type",
            //   label: "Branch Code",
            name: "Customertype",
            description: "Select Customer Type"
          },
          {
            inputType: "showdata",
            tab: "overdraft",
            data: "Customertype",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
          {
            inputType: "displaytext",
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Customer No",
            label: "Customer No",
            name: "",
            description: "Select Customer No"
          },
          {
            inputType: "autocomplete",
            isRequired: true,
            tab: "overdraft",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getRegionCode"
              }
            },
            options: [
              {
                label: "customer-1",
                value: "customer-1"
              },
              {
                label: "customer-2",
                value: "customer-2"
              },
              {
                label: "customer-3",
                value: "customer-3"
              }
            ],
            placeHolder: "Customer Number",
            //   label: "Branch Code",
            name: "CustomerNo",
            description: "Select Customer number"
          },
          {
            inputType: "showdata",
            tab: "overdraft",
            data: "CustomerNo",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
          {
            inputType: "displaytext",
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Account No.",
            label: "Account No.",
            name: "",
            description: "Enter Account No. Text"
          },
          {
            inputType: "numberonly",
            tab: "overdraft",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Enter Account No",
            label: "",
            name: "accountNo",
            description: "Enter Account No"
          },
          {
            inputType: "displaytext",
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Name",
            label: "Name",
            name: "",
            description: "Enter Name"
          },
          {
            inputType: "text",
            tab: "overdraft",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Enter Name",
            label: "",
            name: "name",
            description: "Enter Name"
          },
          {
            inputType: "displaytext",
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Number Of Records",
            label: "Number Of Records",
            name: "",
            description: "Enter Number Of Records"
          },
          {
            inputType: "numberonly",
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Number of Records Number",
            label: "",
            name: "numberOfRecords",
            description: "Enter Number of Records Number"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: true,
            tab: "overdraft",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Active",
            label: "Active",
            name: "active",
            description: "Active"
          },
    ]
  }

  export default minbalance;